// ============================================================
// DM-LMS — useAuth Hook
// DRY: one hook for all auth state across the web app.
// ============================================================

import { useState, useEffect } from "react";
import type { User }           from "@dm-lms/shared/types";
import { API_URL }             from "./useApi.js";

interface AuthState {
  user:      User | null;
  isLoading: boolean;
  error:     string | null;
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({
    user:      null,
    isLoading: true,
    error:     null,
  });

  useEffect(() => {
    async function fetchSession() {
      try {
        const res = await fetch(`${API_URL}/api/auth/me`, { credentials: "include" });
        if (!res.ok) {
          setState({ user: null, isLoading: false, error: null });
          return;
        }
        const json = (await res.json()) as { ok: true; data: User };
        setState({ user: json.data, isLoading: false, error: null });
      } catch {
        setState({ user: null, isLoading: false, error: "Failed to load session" });
      }
    }
    void fetchSession();
  }, []);

  return state;
}
